<template>
  <!-- A group's provinces. One in two groups (ชุมพร, สุราษฎร์ธานี, สงขลา) is
       marked, and its tooltip names the other group: its orders count toward
       both until a trip takes them, which staff need to see at a glance. -->
  <div class="caption grey--text">
    <template v-for="(p, i) in provinces">
      <span v-if="p.also.length" :key="p.name" class="overlap" :title="'อยู่ในกลุ่ม ' + p.also.join(', ') + ' ด้วย'">{{ p.name }}</span>
      <span v-else :key="p.name">{{ p.name }}</span><span v-if="i < provinces.length - 1" :key="p.name + ','">, </span>
    </template>
    <div v-if="hasOverlap" class="overlap-note">ขีดเส้นใต้ = จังหวัดที่อยู่ 2 กลุ่ม (นับให้ทั้งสองกลุ่มจนกว่าจะจัดรอบ)</div>
  </div>
</template>

<script>
import U from '@/components/upcountry'

export default {
  name: 'groupProvinces',
  props: { groupKey: { type: String, required: true } },
  computed: {
    provinces () { return U.provincesOf(this.groupKey) },
    hasOverlap () { return this.provinces.some(p => p.also.length) }
  }
}
</script>

<style scoped>
.overlap {
  font-weight: 600;
  color: #e65100;
  text-decoration: underline;
  text-decoration-color: #e65100;
  text-underline-offset: 2px;
  cursor: help;
}
.overlap-note {
  font-size: 11px;
  color: #e65100;
}
</style>
